/**
 * deploymentHistoryService.ts
 * Feature: 040-deployment-history — Deployment History Tracking
 * Author: Peter Dobler
 * Date: 2026-03-28
 * Constitution Version: 1.12.0
 *
 * Purpose: API client functions for the deployment history feature.
 *          Calls GET /api/deployment-history with serialized query params.
 */

import { apiClient } from './apiClient';
import type {
  DeploymentHistoryFilters,
  DeploymentHistoryResponse,
} from '@shared/types/deploymentHistory';

// =============================================================================
// Constants
// =============================================================================

const BASE_PATH = '/api/deployment-history';

// =============================================================================
// getHistory
// =============================================================================

/**
 * Fetch a paginated, server-side-filtered list of deployment history records.
 * @param filters — optional environment, component, from, to, page, pageSize
 */
export async function getHistory(
  filters: DeploymentHistoryFilters = {}
): Promise<DeploymentHistoryResponse> {
  const params = new URLSearchParams();

  if (filters.environment) params.set('environment', filters.environment);
  if (filters.component) params.set('component', filters.component);
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.page !== undefined) params.set('page', String(filters.page));
  if (filters.pageSize !== undefined) params.set('pageSize', String(filters.pageSize));

  const url = params.toString() ? `${BASE_PATH}?${params.toString()}` : BASE_PATH;
  const response = await apiClient.get<DeploymentHistoryResponse>(url);
  return response.data;
}
